module.exports = __webpack_public_path__ + "static/img/u303.fe011ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u303.png
// module id = vzwF
// module chunks = 1